// extracted by mini-css-extract-plugin
module.exports = {"section":"stackedImages-module--section--I4iPu","backgroundImage":"stackedImages-module--background-image--3U43G","foregroundImage":"stackedImages-module--foreground-image--2yOHZ"};